// @system — reflects the user's `prefers-reduced-motion: reduce` setting (WCAG 2.3.3).
// CSS animations are neutralised globally in app/styles/@system/general.css; this hook is for
// JS-driven motion (smooth scrolling, autoplay, programmatic transitions).
import { useEffect, useState } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

/** @returns {boolean} true when the OS/browser asks for reduced motion */
export function prefersReducedMotion() {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(QUERY).matches
}

/**
 * useReducedMotion — live value of the reduced-motion media query.
 * @returns {boolean}
 */
export function useReducedMotion() {
  const [reduced, setReduced] = useState(prefersReducedMotion)
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined
    const mq = window.matchMedia(QUERY)
    /** @param {MediaQueryListEvent} e */
    const onChange = (e) => setReduced(e.matches)
    mq.addEventListener?.('change', onChange)
    return () => mq.removeEventListener?.('change', onChange)
  }, [])
  return reduced
}
